import { BeforeFetchContext, createFetch } from '@vueuse/core';
import { parse, isPast, add } from 'date-fns';

declare let __RECRUITIS_API_TEMP_TOKEN: string;
declare let __RECRUITIS_API_TEMP_EXPIRATION: string;
declare const __RECRUITIS_BASE_API_URL: string;
declare const __RECRUITIS_CSRF_TOKEN: string;

const refreshToken = async () => {
    const response = await fetch('/api2/login/refresh', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: `Bearer ${__RECRUITIS_API_TEMP_TOKEN}`,
            'With-Credentials': 'true',
            'Recruitis-Data-Session-Version': '1',
        },
    });

    const data = await response.json();

    if (data?.payload?.token) {
        __RECRUITIS_API_TEMP_TOKEN = data.payload.token;
        __RECRUITIS_API_TEMP_EXPIRATION = data.payload.expiration;
    }
};

const injectToken = async ({ options }: BeforeFetchContext) => {
    if (typeof __RECRUITIS_API_TEMP_EXPIRATION !== 'undefined') {
        const expiration = parse(__RECRUITIS_API_TEMP_EXPIRATION, 'yyyy-MM-dd HH:mm:ssX', new Date);

        if (isPast(expiration)) {
            await refreshToken();
        }
    }

    let headers = options.headers || {};

    if (typeof __RECRUITIS_API_TEMP_TOKEN !== 'undefined' && __RECRUITIS_API_TEMP_TOKEN.length > 0) {
        headers = { ...headers, Authorization: `Bearer ${__RECRUITIS_API_TEMP_TOKEN}` };
    }

    return { options: { ...options, headers } };
};

export const useFetchRecruitisApi2 = createFetch({
    baseUrl:
        typeof __RECRUITIS_BASE_API_URL !== 'undefined'
            ? __RECRUITIS_BASE_API_URL
            : import.meta.env.VITE_API_ENDPOINT_PREFIX,
    options: {
        beforeFetch: (ctx: BeforeFetchContext) => {

            if (ctx.url.includes('/api2/api2/')) {
                ctx.url = ctx.url.replace('/api2/api2/', '/api2/');
            }

            return injectToken(ctx);
        },
        onFetchError(ctx) {
            if (ctx.data && ctx.data.meta) {
                ctx.error = ctx.data;
            }
            return ctx;
        },
    },
});
export const useFetchRecruitis = createFetch({
    options: {
        async beforeFetch({ options }) {
            const headers = new Headers(options.headers);
            if (typeof __RECRUITIS_CSRF_TOKEN !== 'undefined') {
                headers.append('X-Csrf-Token', __RECRUITIS_CSRF_TOKEN);
            } else {
                const tokenEl: HTMLMetaElement = document.querySelector('meta[name=csrf-token]');
                if (tokenEl) {
                    headers.append('X-CSRF-Token', tokenEl.content);
                }
            }
            headers.append('X-Requested-With', 'XMLHttpRequest');

            return { options: { ...options, headers } };
        },
    },
});
